// TODO: Move elsewhere
export const ENTERPRISE_PRODUCT_FAMILY_ID = 'f6f474e6-5479-4f1d-9d19-c7c3a31036b2';
const isEnterpriseProduct = product => (product == null ? void 0 : product.productFamilyId) === ENTERPRISE_PRODUCT_FAMILY_ID;
const filterValidProducts = products => products.filter(product => Boolean(product.productId));
const sortProducts = _ref => {
  let {
    products,
    lowToHigh = false
  } = _ref;
  if (!(products != null && products.length)) {
    return [];
  }
  const productsWithFlag = filterValidProducts(products);
  const enterpriseProduct = productsWithFlag.find(isEnterpriseProduct);
  const nonEnterpriseProducts = productsWithFlag.filter(product => !isEnterpriseProduct(product));
  const sortedProducts = enterpriseProduct ? [enterpriseProduct, ...nonEnterpriseProducts] : nonEnterpriseProducts;
  return lowToHigh ? sortedProducts.reverse() : sortedProducts;
};
export const ProductUtils = {
  isEnterpriseProduct,
  filterValidProducts,
  sortProducts
};
//# sourceMappingURL=product-utils.js.map